module.exports = __webpack_public_path__ + "img/waikuang.79db0e9c.png";